import { EditorState } from 'draft-js'
import i18next from 'i18next'
import React from 'react'
import { Editor } from 'react-draft-wysiwyg'

export const RichTextEditor = (props: {
  editorState: EditorState
  onEditorStateChange: (editorState: EditorState) => void
}) => {
  return (
    <Editor
      wrapperClassName="rich-text-editor rte"
      toolbarClassName="rte__toolbar"
      editorClassName="rte__editor text--styled text--s"
      spellCheck
      toolbar={{
        options: ['list'],
        list: {
          inDropdown: false,
          options: ['unordered'],
          unordered: {
            icon: '/spa/images/icons/rte/rte-ul.svg',
            className: 'rte__control',
          },
        },
      }}
      readOnly={false}
      editorState={props.editorState}
      onEditorStateChange={props.onEditorStateChange}
      stripPastedStyles={true}
      localization={{ locale: i18next.language }}
      handleKeyCommand={() => 'not-handled'}
    />
  )
}
